import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import Sidebar from './Sidebar';

function Layout({ children, title = 'Sistema' }) {
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  // Cerrar menú al navegar
  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname, location.search]);

  // Escape para cerrar
  useEffect(() => {
    const onKey = (e) => e.key === 'Escape' && setMenuOpen(false);
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, []);

  // Bloquear scroll del body cuando el drawer está abierto (móvil)
  useEffect(() => {
    document.body.style.overflow = menuOpen ? 'hidden' : '';
    return () => (document.body.style.overflow = '');
  }, [menuOpen]);

  return (
    <div className="app-layout">
      {/* Topbar móvil */}
      <header className="app-topbar">
        <button
          type="button"
          className="app-hamburger"
          aria-label="Abrir menú"
          aria-expanded={menuOpen}
          onClick={() => setMenuOpen(true)}
        >
          ☰
        </button>
        <div className="app-topbar-title">{title}</div>
      </header>

      {/* Overlay móvil */}
      <div className={`app-overlay ${menuOpen ? 'open' : ''}`} onClick={() => setMenuOpen(false)} />

      {/* Sidebar: desktop fijo, móvil drawer */}
      <aside className={`app-sidebar ${menuOpen ? 'open' : ''}`}>
        <div className="app-sidebar-head">
          <b>Menú</b>
          <button
            type="button"
            className="app-sidebar-close"
            onClick={() => setMenuOpen(false)}
            aria-label="Cerrar"
          >
            ×
          </button>
        </div>

        <div className="app-sidebar-body">
          <Sidebar />
        </div>
      </aside>

      {/* Contenido */}
      <main className="app-main">
        <div className="app-scroll-area">{children}</div>
      </main>
    </div>
  );
}

export default Layout;
